<template>

    <div
        v-if="current !== null"
        :class="{'page-title':true, 'page-title-image': hasImage}"
        :style="getStyle"
    >
        <div
            :class="{
                'row': true,
                'headerless': !shouldShowHeader
            }"
        >
            <div
                v-if="current.length > 0 && !isError"
                class="col-12"
            >
                <h1
                    v-if="shouldShowHeader"
                    v-html="current[current.length - 1].name"
                ></h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li
                            v-for="(trail, index) in current"
                            :class="{'breadcrumb-item':true,'active':index === current.length - 1}"
                        >
                            <span
                                v-if="index === current.length - 1"
                                v-html="trail.name"
                            ></span>
                            <inertia-link
                                v-else
                                :href="trail.route"
                                v-html="trail.name"
                            ></inertia-link>
                        </li>
                    </ol>
                </nav>
            </div>
            <div
                v-else
                class="col-12"
            >
                <h1><span v-if="$appError.code() !== ''">{{ $appError.code() }} &ndash; </span>{{ $appError.msg() }}</h1>
            </div>
        </div>
    </div>

</template>

<script>

import breadcrumbs from "../breadcrumbs";

export default {

    computed: {
        current() {
            if (typeof this.currentRoute === "undefined" || !breadcrumbs[this.routeNow]){
                return null;
            }
            return breadcrumbs[this.routeNow](this.page);
        },

        error() {
            return this.$appError;
        },

        getImage() {
            if (!this.hasImage) {
                return '';
            }
            return this.$pageTitleImage.get();
        },

        getStyle() {
            if (!this.hasImage) {
                return '';
            }
            return 'background-image:url(' + this.getImage + ')';
        },

        hasImage() {
            return this.$pageTitleImage.has();
        },

        isError() {
            return this.$appError.isError();
        },

        routeNow() {
            return typeof this.currentRoute === 'undefined' ?
                'content.index' :
                this.currentRoute;
        },

        shouldShowHeader() {
            return this.$pageHeader.state();
        },
    },

    name:'PageTitle',

    props: {
        currentRoute: {
            required:true,
        },
        page: {
            required:true,
        },
    },

}

</script>
